import { MONTH_NAME_LIST } from './date.constants';

export function convertMonthNameToFirstDayDate(name: string, refDate: Date = new Date()): Date {
	const monthIndex = MONTH_NAME_LIST.indexOf(name.toUpperCase());
	if (monthIndex === -1) {
		throw new Error('Invalid month name');
	}

	const year = refDate.getFullYear();
	return new Date(year, monthIndex, 1);
}

export function formatDate(date: Date, format: string): string {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	const hours = String(date.getHours()).padStart(2, '0');
	const minutes = String(date.getMinutes()).padStart(2, '0');
	const seconds = String(date.getSeconds()).padStart(2, '0');
	const milliseconds = String(date.getMilliseconds()).padStart(3, '0');

	return format
		.replaceAll(/yyyy/g, year.toString())
		.replaceAll(/MM/g, month)
		.replaceAll(/dd/g, day)
		.replaceAll(/HH/g, hours)
		.replaceAll(/mm/g, minutes)
		.replaceAll(/ss/g, seconds)
		.replaceAll(/SSS/g, milliseconds)
		.replaceAll(/M/g, String(date.getMonth() + 1))
		.replaceAll(/d/g, String(date.getDate()))
		.replaceAll(/H/g, String(date.getHours()))
		.replaceAll(/m/g, String(date.getMinutes()))
		.replaceAll(/s/g, String(date.getSeconds()));
}

export function extractNameOfMonthFromDate(date: Date): string {
	return date.toLocaleDateString('default', { month: 'long' });
}
